import {CSSProperties, FC} from 'react';


export interface IIconCartNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconCartNissan: FC<IIconCartNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M18.46 15.187H7.804c-.42 0-.761-.358-.761-.8 0-.44.34-.798.761-.798h7.945c1.047 0 1.96-.748 2.215-1.814l1.255-5.186a.83.83 0 0 0-.137-.687.747.747 0 0 0-.624-.304H7.622C7.301 4.643 6.442 4.003 5.476 4h-.715C4.341 4 4 4.358 4 4.8c0 .44.34.798.761.798h.715a.768.768 0 0 1 .761.607l.046.384L7.6 11.99c-1.261.06-2.237 1.18-2.18 2.505.056 1.324 1.124 2.348 2.385 2.289h.137c-.344.995-.026 2.11.783 2.741a2.196 2.196 0 0 0 2.726 0c.809-.632 1.127-1.746.783-2.741h1.796c-.344.995-.025 2.11.783 2.741a2.196 2.196 0 0 0 2.726 0c.809-.632 1.127-1.746.783-2.741h.137c.42 0 .761-.358.761-.8 0-.44-.34-.798-.76-.798Zm-.975-7.99-.997 4.186a.768.768 0 0 1-.76.608H9.16L8.018 7.196h9.467Zm-7.397 11.186c-.42 0-.76-.358-.76-.799 0-.441.34-.799.76-.799s.761.358.761.799c0 .441-.34.8-.76.8Zm6.088 0c-.42 0-.76-.358-.76-.799 0-.441.34-.799.76-.799s.761.358.761.799c0 .441-.34.8-.76.8Z" clipRule="evenodd" />
        </svg>
    );
};
